import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { MilestoneIcon } from "@common/milestoneIcon";
import { Props } from "./types";
import { Flag } from "./flag";
import styles from "./styles.scss";

function Milestone({ milestone, project, percentage, isDone, isLate }: Props) {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(styles.milestone, {
        [styles.late]: isLate,
        [styles.done]: isDone,
      })}
    >
      <MilestoneIcon className={styles.icon} />
      <div
        className={classNames(styles.popup, { [styles.left]: percentage > 50 })}
      >
        <Flag className={styles.flag} />
        <div className={styles.infos}>
          <p className={styles.name}>{milestone.name}</p>
          {!!milestone.endDate && (
            <div className={styles.group}>
              <p className={styles.label}>
                {t("projectPage.synthesisPage.monitoring.endDate")}
              </p>
              <p className={styles.text}>
                {new Date(milestone.endDate).toLocaleDateString()}
              </p>
            </div>
          )}
          {isDone && (
            <div className={styles.group}>
              <p className={styles.label}>
                {t("projectPage.synthesisPage.monitoring.completionDate")}
              </p>
              <p className={styles.text}>
                {new Date(milestone.completedAt).toLocaleDateString()}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export { Milestone };
